import Box from "@mui/material/Box";
import { CalendarClock, Info, MapPin, Phone } from "lucide-react";
import TopBarMobileLinks from "./TopBarMobileLinks";
import ContactLink from "@v2/components/ContactLink";

const LINKS = [
    { label: "درباره ما", href: "/fa/about-us", icon: Info, target: "_self" },
    { label: "مسیریابی به فروشگاه", href: "geo:35.726363, 51.322396", icon: MapPin, target: "_self" },
    { label: "رزرو وقت بینایی سنجی", href: "https://eynakology.com/", icon: CalendarClock, target: "_blank" },
];

const PHONE = "02144042260";
const PHONE_DISPLAY = "۴۴۰۴۲۲۶۰";

export default function TopBar() {
    return (
        <Box
            id="top-bar"
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                bgcolor: "#101010",
                display: "flex",
                height: 36,
                alignItems: "center",
            }}
        >
            <Box
                sx={{
                    maxWidth: 1400,
                    width: 1,
                    mx: "auto",
                    px: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    boxSizing: "content-box",
                }}
            >
                {/* mobile: rotating links */}
                <TopBarMobileLinks />

                {/* desktop: all links */}
                <Box
                    sx={{
                        display: { xs: "none", md: "flex" },
                        alignItems: "center",
                        color: "#bbb",
                        fontSize: 13,
                        "& a": {
                            color: "inherit",
                            textDecoration: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            transition: "color 0.2s",
                            "&:hover": { color: "#fff" },
                        },
                    }}
                >
                    {LINKS.map((link, i) => {
                        const Icon = link.icon;
                        return (
                            <Box key={link.href} sx={{ display: "flex", alignItems: "center" }}>
                                {i > 0 && (
                                    <Box sx={{ width: "1px", height: 14, bgcolor: "rgba(255,255,255,0.2)", mx: 1.5 }} />
                                )}
                                <a href={link.href} target={link.target}>
                                    <Icon size={13} color="#fff" />
                                    {link.label}
                                </a>
                            </Box>
                        );
                    })}
                </Box>

                <ContactLink
                    channel="phone"
                    location="header"
                    href={`tel:${PHONE}`}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75,
                        color: "#bbb",
                        fontSize: 13,
                        textDecoration: "none",
                        transition: "color 0.2s",
                        "&:hover": { color: "#fff" },
                    }}
                >
                    <span>{PHONE_DISPLAY}</span>
                    <Phone size={14} color="#fff" />
                </ContactLink>
            </Box>
        </Box>
    );
}
